export const ITEMS_PER_PAGE = 50;

export const TAB_LIST = [
  { langKey: 'content.CONTENT_LIST', to: { name: 'content-list' } },
  { langKey: 'content.DRAFT_CONTENT_LIST', to: { name: 'content-list-draft' } },
];

export const StatusTypes = [
  {
    langKey: 'STATUS_APPROVE',
    value: 1,
    color: 'success',
    shortLangKey: 'SHORT_STATUS_APPROVE',
    textColor: 'green',
  },
  {
    langKey: 'STATUS_UNAPPROVE',
    value: 2,
    color: 'error',
    shortLangKey: 'SHORT_STATUS_UNAPPROVE',
    textColor: 'red',
  },
];

export const ContentListTab = 0;
export const PendingContentListTab = 1;
export const DraftContentListTab = 2;

export const NewsTypes = [
  {
    value: 1,
    langKey: 'NEWS_TYPE_HOT',
    color: '#F00000',
  },
  {
    value: 2,
    langKey: 'NEWS_TYPE_COLD',
    color: '#0066FF',
  },
  {
    value: 3,
    langKey: 'NEWS_TYPE_NEWSPAPER',
    color: '#808080',
  },
  {
    value: 4,
    langKey: 'NEWS_TYPE_NONE',
    color: '#cccccc',
  },
];

export const Smiles = [
  {
    value: 1,
    langKey: 'SHOW',
  },
  {
    value: 2,
    langKey: 'HIDE',
  },
];

export const NotificationTypes = [
  {
    value: 'web',
    langKey: 'WEB',
  },
  {
    value: 'mobile',
    langKey: 'MOBILE',
  },
  {
    value: 'special',
    langKey: 'SPECIAL',
  },
];

export const ContentVideoValidations = {
  extensions: 'mp4',
  accept: 'video/mp4',
};

export const PromotionTypes = [
  {
    value: 1,
    langKey: 'WITH_PRODUCT_CONTENT',
    color: '#00b300',
  },
  {
    value: 2,
    langKey: 'PUBLIC_SPOT',
    color: '#404040',
  },
];

export const socialMedias = {
  facebook: 'Facebook',
  twitter: 'X',
  instagram: 'Instagram',
  whatsapp: 'Whatsapp',
  threads: 'Threads',
  telegram: 'Telegram',
  nextSocial: 'Next Sosyal',
};

export const ContentAutomatedTestIds = {
  ALL_CONTENT_LIST: 'all-content-list',
  ALL_PENDING_CONTENT_LIST: 'all-pending-content-list',
  INPUT_CONTENT_VIDEO: 'input-content-video-add',
  INPUT_CONTENT_EMBED: 'input-content-embed-add',
  CONTENT_VIDEO_DRAG_DROP_FILE_AREA: 'input-content-video-drag-drop-file-area',
  INPUT_CONTENT_VIDEO_RADIO_BUTTON_FILE: 'input-content-video-radio-button-file',
  INPUT_CONTENT_VIDEO_RADIO_BUTTON_EMBED: 'input-content-video-radio-button-embed',
  CONTENT_VIDEO_EMBED_CLEAN_BUTTON: 'content-video-embed-clean-button',
  CONTENT_VIDEO_INFORMATION_BUTTON: 'content-video-information-button',
  DROPDOWN_APPROVE_STATUS: 'filter-content-dropdown-approve-status',
  RENDER_LIST_CHECK_ELEMENT: 'render-list-check-element',
  BUTTON_EDIT_CONTENT: 'content-action-edit-button',
};

export const contentManagementListAutomatedTestIds = {
  FILTER_INPUT_SEARCH: 'filter-input-search',
  FILTER_INPUT_PHO_DATE_TIME_PICKER: 'filter-input-pho-date-time-picker',
  FILTER_INPUT_PHO_DATE_TIME_PICKER_MENU: 'filter-input-pho-date-time-picker-menu',
  DROPDOWN_CONTENT_TYPE: 'filter-content-type',
  DROPDOWN_INPUT_CATEGORIES: 'filter-categories',
  DROPDOWN_INPUT_USER_LIST: 'filter-user-list',
};

export const draftAutomatedTestIds = {
  ALL_DRAFT_LIST: 'all-draft-list',
  CONTENT_DRAFT: 'content-draft',
};

export const ContentHeader = [
  {
    value: 'statuses', sortable: false, langPath: 'status', langKey: 'STATUS',
  },
  {
    text: 'ID', value: 'id', sortable: false,
  },
  {
    value: 'date', sortable: false, langPath: 'content', langKey: 'CONTENT_DATE',
  },
  {
    value: 'title_spot', sortable: false, langPath: 'content', langKey: 'TITLE_AND_SPOT',
  },
  {
    value: 'type', sortable: false, langPath: 'content', langKey: 'CONTENT_TYPE',
  },
  {
    value: 'categories', sortable: false, langPath: 'content', langKey: 'CATEGORY',
  },
  {
    value: 'agency', sortable: false, langPath: 'content', langKey: 'AGENCY', align: 'center',
  },
  {
    value: 'editor', sortable: false, langPath: 'content', langKey: 'EDITOR',
  },
  {
    value: 'signatures', sortable: false, langPath: 'signature', langKey: 'SIGNATURES',
  },
  {
    value: 'other', sortable: false, langPath: 'app', langKey: 'OTHER',
  },
];

export const DraftContentHeader = [
  {
    value: 'date', sortable: false, langPath: 'draft', langKey: 'DRAFT_DATE',
  },
  {
    value: 'title_spot', sortable: false, langPath: 'content', langKey: 'TITLE_AND_SPOT',
  },
  {
    value: 'type', sortable: false, langPath: 'content', langKey: 'CONTENT_TYPE',
  },
  {
    value: 'categories', sortable: false, langPath: 'content', langKey: 'CATEGORY',
  },
  {
    value: 'editor', sortable: false, langPath: 'content', langKey: 'EDITOR',
  },
  {
    value: 'other', sortable: false, langPath: 'app', langKey: 'OTHER',
  },
];
